import * as React from 'react'
import BaseIcon from 'react-icon-base'
import { IIconProps } from './interface'

const FeedActiveIcon = (props: IIconProps) => (
  <BaseIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      fill="#2ED8A7"
      fillRule="evenodd"
      d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm3 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm4-1v1h4V6H9zM3 9v1h10V9H3zm0 3v1h10v-1H3z"
    />
  </BaseIcon>
)

export default FeedActiveIcon
